module.exports = __webpack_public_path__ + "img/weddingrings.a8c22be.jpg";